<script>
import { serviceColors } from "../../../config/transaction"

export default {
  props: {
    transaction: {
      type: String,
      required: true
    }
  },
  computed: {
    serviceColors
  },
  data() {
    return {
      loading: false,
      items: {},
      modal: {
        visible: false,
        item: {}
      },
      columns: [
        {
          dataIndex: 'created_at',
          key: 'created_at',
          title: 'Date Time',
          width: 150,
          scopedSlots: {customRender: 'datetime'}
        }, {
          dataIndex: 'type',
          key: 'type',
          title: 'Service',
          width: 100,
          scopedSlots: {customRender: 'service'}
        }, {
          dataIndex: 'driver',
          key: 'driver',
          title: 'Driver',
          scopedSlots: {customRender: 'driver'}
        }, {
          dataIndex: 'biller_price',
          key: 'biller_price',
          title: 'Price',
          scopedSlots: {customRender: 'price'}
        }, {
          dataIndex: 'status',
          key: 'status',
          title: 'Status',
          scopedSlots: {customRender: 'status'}
        }, {
          key: 'action',
          title: '',
          scopedSlots: {customRender: 'action'}
        }
      ],
      filters: {
        q: null,
      }
    }
  },
  mounted() {
    this.items = this.getDefaultPagination()
    this.getItems()
  },
  methods: {
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.transaction.biller-response', {transaction_uuid: this.transaction}) + '?q=')
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small">
    <a-skeleton :loading="loading" active>
      <a-table :columns="columns" :dataSource="items.data" :pagination="false" rowKey="id">
        <h5 slot="datetime" slot-scope="datetime" class="text-center">
          {{ datetime }}
        </h5>

        <span slot="service" slot-scope="service" :style="{textAlign: 'center'}">
                    <a-tag :color="serviceColors[service]">{{ service.toUpperCase() }}</a-tag>
                </span>

        <div slot="biller" slot-scope="biller">
          <h2>{{ biller }}</h2>
        </div>

        <h4 slot="price" slot-scope="price" :style="{ color: price >= 0 ? '#237804' : '#a8071a'}">{{
            currency(price)
          }}</h4>

        <span slot="status" slot-scope="status">
                    <a-tag :color="status==='success' ? '#87d068' : (status==='pending' ? '#faad14' : '#fa541c')">
                        {{ status.toUpperCase() }}
                    </a-tag>
                </span>

        <div slot="action" class="text-center" slot-scope="record">
          <a-tooltip title="Source">
            <a-button size="small" type="dashed" shape="circle" icon="code"
                      @click="() => modal = { visible: true, item: record }"/>
          </a-tooltip>
        </div>
      </a-table>
    </a-skeleton>

    <a-modal title="Source" v-model="modal.visible" @ok="() => modal = { visible: false, item: {} }">
      <div class="code-bg">
        <vue-json-pretty :data="modal.item" :deep="1"/>
        <div class="extra">
          <a-button type="link" icon="copy" size="small" @click="copy(JSON.stringify(modal.item, null, 1), 'Source has been successfully copied to your clipboard.')"/>
        </div>
      </div>
    </a-modal>
  </a-card>
</template>
